// extracted by mini-css-extract-plugin
export default {"wrapper":"FamilyNews_wrapper__gASPC","news_list":"FamilyNews_news_list__Oxvkw","description":"FamilyNews_description__ywEGe"};